<template>
  <div class="courses-page-container mt-2 mb-5 mx-5 mt-sm-5 mb-sm-15 mx-sm-10 rounded-xl pa-5">
    <v-row v-if="havePermissionGetSubscriberStatistics" class="px-3">
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="2"
        v-for="(statistics, index) in statisticsData"
        :key="index"
        class="px-0"
      >
        <statistics-card :data="statistics" @onClick="onCardClick(index)" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <available-courses
          @statisticsReRender="statisticsReRender"
          ref="coursesTable"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col> <enrolled-employees /> </v-col>
    </v-row>
  </div>
</template>

<script>
import StatisticsCard from "../../statistics-module/components/StatisticsCard.vue";
import AvailableCourses from "../components/AvailableCourses.vue";
import EnrolledEmployees from "../components/EnrolledEmployees.vue";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    StatisticsCard,
    AvailableCourses,
    EnrolledEmployees,
  },
  data() {
    return {
      statisticsData: [
        {
          value: 0,
          name: "totalAvailableTrainings",
          text: this.$t("statistics.availableCourses"),
          icon: "mdi-account-supervisor-outline",
          divider: true,
        },
        {
          value: 0,
          name: "totalRegistrations",
          text: this.$t("statistics.totalEnrolments"),
          icon: "mdi-book-open-page-variant-outline",
          divider: true,
          routeName: "Registrations",
        },
        {
          value: 0,
          name: "totalTrainers",
          text: "Total Trainers",
          icon: "mdi-account-group-outline",
          divider: true,
          routeName: "EmployeesRoles",
        },
        {
          value: 0,
          name: "totalApprovalPendingTrainings",
          text: this.$t("statistics.pendingApprovals"),
          icon: "mdi-clipboard-clock-outline",
          divider: true,
        },
        // {
        //   value: 0,
        //   name: "totalDisabledTrainings",
        //   text: this.$t("statistics.disabledCourses"),
        //   icon: "mdi-block-helper",
        //   divider: true,
        // },
        {
          value: 0,
          name: "totalCompletions",
          text: this.$t("statistics.totalCompletions"),
          icon: "mdi-check-circle-outline",
          divider: true,
          routeName: "Registrations",
        },
        {
          value: 0,
          name: "totalRejectedTrainings",
          text: this.$t("statistics.rejectedCourses"),
          icon: "mdi-folder-arrow-left-outline",
          divider: false,
        },
      ],
    };
  },
  computed: {
    havePermissionGetSubscriberStatistics() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_SUBSCRIBER_STATISTICS"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionCreateTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  created() {
    this.$apollo.queries.getSubscriberStatistics.refetch();
  },
  apollo: {
    getSubscriberStatistics() {
      return {
        query: require("../../statistics-module/api/query/getSubscriberStatistics.gql"),
        result({ data }) {
          if (data && data.getSubscriberStatistics) {
            Object.entries(data.getSubscriberStatistics).forEach(
              ([key, value]) => {
                this.statisticsData = this.statisticsData.map(data => {
                  if (data.name === key) {
                    if (key === "totalRevenue") {
                      data.value = value ? "$ " + value : "$ " + 0;
                    } else {
                      data.value = value ? value : 0;
                    }
                  }
                  return data;
                });
              }
            );
          }
        },
        skip() {
          return !this.havePermissionGetSubscriberStatistics;
        },
      };
    },
  },
  methods: {
    statisticsReRender() {
      this.$apollo.queries.getSubscriberStatistics.refetch();
    },
    onCardClick(i) {
      if (this.statisticsData[i]?.routeName) {
        if (this.statisticsData[i]?.name === "totalTrainers") {
          this.$router.push({
            name: this.statisticsData[i]?.routeName,
            params: { role: "TRAINER" },
          });
        } else if (this.statisticsData[i]?.name === "totalCompletions") {
          this.$router.push({
            name: this.statisticsData[i]?.routeName,
            params: { status: "COMPLETED" },
          });
        } else {
          this.$router.push({
            name: this.statisticsData[i]?.routeName,
          });
        }
      } else {
        if (this.statisticsData[i]?.name === "totalAvailableTrainings") {
          this.$refs.coursesTable.setCourseTypeFilter("APPROVED");
        } else if (
          this.statisticsData[i]?.name === "totalApprovalPendingTrainings"
        ) {
          this.$refs.coursesTable.setCourseTypeFilter("PENDING");
        } else if (this.statisticsData[i]?.name === "totalRejectedTrainings") {
          this.$refs.coursesTable.setCourseTypeFilter("REJECTED");
        }
      }
    },
  },
};
</script>

<style scoped>
.courses-page-container {
  background: linear-gradient(180deg, #fbfbfd 0%, #f4f5f8 100%);
  min-height: calc(100vh - 100px);
}
</style>
